import { useFormikContext } from 'formik'
import React from 'react'
import CloseIcon from '../../../../../../../components/icons/CloseIcon'
import {
  Chips,
  MainQualificationDiv,
  QualificationDiv,
} from '../../style/style'
import { Divider, Spin } from 'antd'
import styled from 'styled-components'
import { buildEligibilityPayload, processNewFormat } from '../../../../../../../helpers/formHelpers'

export const Separator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  font-weight: 550;
  width: 100%;
  padding-left: 1em;
  gap: 0.3em;
`
export const StyledDivider = styled(Divider)`
  font-size: smaller !important;
  font-weight: 700 !important;
  border-top-color: black !important;
  transform: none !important;

  &.ant-divider-horizontal.ant-divider-with-text::before,
  &.ant-divider-horizontal.ant-divider-with-text::after {
    position: relative;
    width: 50%;
    border-top: 1px solid transparent;
    border-top-color: inherit;
    border-bottom: 0;
    transform: none !important;
    content: '';
  }
`
export default function QualificationSelectionBubbleWithDummyData({
  courseData = [],
  setCourseData,
  isShow = true,
  handleQualicationChange,
  disabled,
  setSelectedCourses,
  isAllSelected,
  setIsAllSelected,
  isLoading,
  rePublishedPublishDisabled
}) {
  const { values, setFieldValue } = useFormikContext
    ? useFormikContext()
    : { values: {} }
  const qualification = values?.elgibilty?.qualification || 'Degree'
  const isAll = values?.elgibilty?.allSelected

  const handleRemoveChip = (chip, index) => {
    const parts = chip.split(' - ')
    
    setSelectedCourses(prevData => {
      const newData = [...prevData]
      const currentItem = [...(newData[index] || [])]
      
      // Case 1: Removing a degree (no stream specified)
      if (parts.length === 1) {
        // Filter out the degree that matches the chip
        const filteredArray = newData.map((typeArray, idx) => {
          if (idx !== index) return typeArray
          return typeArray.filter(degree => degree.degreeShortForm !== parts[0])
        })
        
        // Update formik state
        const payload = filteredArray.map(criteria => 
          buildEligibilityPayload([...criteria])
        )
        setFieldValue('elgibilty.eligibilityCriteria', payload)
        
        return filteredArray
      }
      
      // Case 2: Removing a specific stream
      if (parts.length === 2) {
        const updatedItem = currentItem.map(degree => {
          // Skip degrees that don't match
          if (degree.degreeShortForm !== parts[0]) return degree
          
          // Update streams in the matching degree
          const updatedStreams = (degree.streams || []).map(stream => {
            // Only modify the stream that matches
            if (stream.streamName.trim() !== parts[1].trim()) return stream
            
            // Mark the stream and all its specializations as unselected
            return {
              ...stream,
              isSelected: false,
              specializations: (stream.specializations || []).map(spec => ({
                ...spec,
                isSelected: false
              })),
              specialisations: (stream.specialisations || []).map(spec => ({
                ...spec,
                isSelected: false
              }))
            }
          })
          
          return {
            ...degree,
            streams: updatedStreams,
            // Degree should remain selected if any other stream is still active
            isSelected: updatedStreams.some(s => s.isSelected)
          }
        })
        
        // Filter out degrees that are no longer selected
        const filteredItem = updatedItem.filter(degree => degree.isSelected)
        newData[index] = filteredItem
        
        // Update formik state
        const payload = newData.map(criteria => 
          buildEligibilityPayload([...criteria])
        )
        setFieldValue('elgibilty.eligibilityCriteria', payload)
        
        return newData
      }
      
      // Case 3: Removing a specialization
      if (parts.length === 3) {
        const updatedItem = currentItem.map(degree => {
          // Skip degrees that don't match
          if (degree.degreeShortForm !== parts[0]) return degree
          
          const updatedStreams = (degree.streams || []).map(stream => {
            // Skip streams that don't match
            if (stream.streamName.trim() !== parts[1].trim()) return stream
            
            // Update specializations
            const updatedSpecs = (stream.specializations || []).map(spec => ({
              ...spec,
              isSelected: spec.specialisationName === parts[2] ? false : spec.isSelected
            }))
            
            const updatedSpecsAlt = (stream.specialisations || []).map(spec => ({
              ...spec,
              isSelected: spec.specialisationName === parts[2] ? false : spec.isSelected
            }))
            
            // Stream is selected if any specialization is still selected
            const streamStillSelected = 
              updatedSpecs.some(s => s.isSelected) || 
              updatedSpecsAlt.some(s => s.isSelected)
            
            return {
              ...stream,
              specializations: updatedSpecs,
              specialisations: updatedSpecsAlt,
              isSelected: streamStillSelected
            }
          })
          
          // Degree is selected if any stream is still selected
          const degreeStillSelected = updatedStreams.some(s => s.isSelected)
          
          return {
            ...degree,
            streams: updatedStreams,
            isSelected: degreeStillSelected
          }
        })
        
        // Filter out degrees that are no longer selected
        const filteredItem = updatedItem.filter(degree => degree.isSelected)
        newData[index] = filteredItem
        
        // Update formik state
        const payload = newData.map(criteria => 
          buildEligibilityPayload([...criteria])
        )
        setFieldValue('elgibilty.eligibilityCriteria', payload)
        
        return newData
      }
      
      return newData
    })
  }
  
  const unselectAll = (chip, index) => {
    const degreeTypeToRemove = chip?.degreeType || chip?.type

    setSelectedCourses(prev => {
      // 1. Create a deep copy of the current state, preserving all indices
      const newState = prev
        ? prev.map(item => (Array.isArray(item) ? [...item] : []))
        : []

      // 2. Get current criteria at index or initialize empty array
      const currentCriteria = Array.isArray(newState[index])
        ? [...newState[index]]
        : []

      // 3. Filter out the degree type to remove
      const updatedCriteria = currentCriteria.filter(item => {
        const itemType = item.degreeType || item.type
        return itemType !== degreeTypeToRemove
      })

      // 4. Only update the specific index that changed
      const finalState = newState.map((item, idx) =>
        idx === index ? [...updatedCriteria] : [...item]
      )

      // 5. Update formik state to match
      const newEligibility = finalState.map(criteria =>
        buildEligibilityPayload([...criteria])
      )

      setFieldValue('elgibilty.eligibilityCriteria', newEligibility)

      return finalState
    })
  }

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px',
          }}
        >
          <Spin size="small" />
        </div>
      ) : (
        isShow &&
        courseData?.some(item => item?.length > 0) && (
          <MainQualificationDiv>
            <QualificationDiv>Qualification</QualificationDiv>
            {courseData?.map((item, index) => {
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {processNewFormat(item)?.map((chip, idx) => (
                    <Chips
                      key={chip.label + idx}
                      disabled={rePublishedPublishDisabled}
                    >
                      {chip.label}
                      {setCourseData && (
                        <span
                          style={{
                            marginLeft: 8,
                            cursor: rePublishedPublishDisabled
                              ? 'not-allowed'
                              : 'pointer',
                            opacity: rePublishedPublishDisabled ? 0.5 : 1,
                            pointerEvents: rePublishedPublishDisabled
                              ? 'none'
                              : 'auto',
                          }}
                          onClick={() => {
                            if (rePublishedPublishDisabled) return // safeguard
                            if (chip.isAll) {
                              unselectAll(chip.degreeObj, index)
                            } else {
                              handleRemoveChip(chip.label, index)
                            }
                          }}
                        >
                          <CloseIcon width={15} height={15} />
                        </span>
                      )}
                    </Chips>
                  ))}
                  {index < courseData.length - 1 &&
                    courseData[index + 1]?.length > 0 && (
                      <Separator>
                        {' '}
                        AND
                        <StyledDivider
                          orientation="left"
                          orientationMargin="0"
                        />
                      </Separator>
                    )}
                </div>
              )
            })}
          </MainQualificationDiv>
        )
      )}
    </div>
  )
}
